import { createFileRoute } from '@tanstack/react-router'
import { APP_NAME } from '@/lib/utils'
import Packaging from '@/features/packaging'

export const Route = createFileRoute('/_authenticated/packaging/')({
  component: Packaging,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Emballages`,
      },
    ],
  }),
  // beforeLoad: async () => {
  //   try {
  //     const res = await getCurrentUser()
  //     if (!res?.id) {
  //       throw redirect({
  //         to: '/sign-in-2',
  //       })
  //     }
  //   } catch (_) {
  //     throw redirect({
  //       to: '/sign-in-2',
  //     })
  //   }
  // },
})
